$(document).ready(function () {
  var data = {
    "Single Breasted Jacket": {
      "Body Measurements": {
        "Size": [36, 38, 40, 42, 44, 46, 48, 50],
        "Jacket Length": [
          { "cm": 74, "inch": 29.1 },
          { "cm": 75, "inch": 29.5 },
          { "cm": 76, "inch": 29.9 },
          { "cm": 77, "inch": 30.3 },
          { "cm": 78, "inch": 30.7 },
          { "cm": 79, "inch": 31.1 },
          { "cm": 80, "inch": 31.4 },
          { "cm": 80, "inch": 31.4 }
        ],
        "Chest Width": [
          { "cm": 98, "inch": 38.5 },
          { "cm": 102, "inch": 40.1 },
          { "cm": 102, "inch": 40.1 },
          { "cm": 110, "inch": 43.3 },
          { "cm": 114, "inch": 44.8 },
          { "cm": 116, "inch": 45.6 },
          { "cm": 120, "inch": 47.2 },
          { "cm": 124, "inch": 48.8 }
        ],
        "Shoulder Width": [
          { "cm": 43, "inch": 16.9 },
          { "cm": 44, "inch": 17.3 },
          { "cm": 45, "inch": 17.7 },
          { "cm": 46, "inch": 18.1 },
          { "cm": 48, "inch": 18.5 },
          { "cm": 49, "inch": 18.8 },
          { "cm": 50, "inch": 19.2 },
          { "cm": 51, "inch": 19.6 }
        ],
        "Waist Width": [
          { "cm": 95, "inch": 37.4 },
          { "cm": 97, "inch": 38.1 },
          { "cm": 100, "inch": 39.3 },
          { "cm": 103, "inch": 40.5 },
          { "cm": 106, "inch": 41.7 },
          { "cm": 109, "inch": 42.9 },
          { "cm": 113, "inch": 44.4 },
          { "cm": 117, "inch": 46.0 }
        ],
        "Sleeve Length": [
          { "cm": 62.5, "inch": 24.6 },
          { "cm": 62.5, "inch": 24.6 },
          { "cm": 63, "inch": 24.8 },
          { "cm": 64, "inch": 25.1 },
          { "cm": 65.5, "inch": 25.7 },
          { "cm": 65.5, "inch": 25.7 },
          { "cm": 67.5, "inch": 26.5 },
          { "cm": 67.5, "inch": 26.5 }
        ],
        "Bicep Width": [
          { "cm": 37, "inch": 14.5 },
          { "cm": 37, "inch": 14.5 },
          { "cm": 39, "inch": 15.3 },
          { "cm": 40, "inch": 15.7 },
          { "cm": 40, "inch": 15.7 },
          { "cm": 41, "inch": 16.1 },
          { "cm": 41, "inch": 16.1 },
          { "cm": 41, "inch": 16.1 }
        ],
        "Wrist Width": [
          { "cm": 26, "inch": 10.2 },
          { "cm": 26, "inch": 10.2 },
          { "cm": 27, "inch": 10.6 },
          { "cm": 28, "inch": 11.0 },
          { "cm": 28, "inch": 11.0 },
          { "cm": 28, "inch": 11.0 },
          { "cm": 29, "inch": 11.4 },
          { "cm": 29, "inch": 11.4 }
        ]
      },
      "Jacket Measurements": {
        "Size": [36, 38, 40, 42, 44, 46, 48, 50],
        "Jacket Length": [
          { "cm": 74, "inch": 29.1 },
          { "cm": 75, "inch": 29.5 },
          { "cm": 76, "inch": 29.9 },
          { "cm": 77, "inch": 30.3 },
          { "cm": 78, "inch": 30.7 },
          { "cm": 79, "inch": 31.1 },
          { "cm": 80, "inch": 31.4 },
          { "cm": 80, "inch": 31.4 }
        ],
        "Chest Width": [
          { "cm": 49, "inch": 19.2 },
          { "cm": 51, "inch": 20.0 },
          { "cm": 51, "inch": 20.0 },
          { "cm": 55, "inch": 21.6 },
          { "cm": 57, "inch": 22.4 },
          { "cm": 58, "inch": 22.8 },
          { "cm": 60, "inch": 23.6 },
          { "cm": 62, "inch": 24.4 }
        ],
        "Shoulder Width": [
          { "cm": 43, "inch": 16.9 },
          { "cm": 44, "inch": 17.3 },
          { "cm": 45, "inch": 17.7 },
          { "cm": 46, "inch": 18.1 },
          { "cm": 48, "inch": 18.8 },
          { "cm": 49, "inch": 19.2 },
          { "cm": 50, "inch": 19.6 },
          { "cm": 51, "inch": 20.0 }
        ],
        "Waist Width": [
          { "cm": 47.5, "inch": 18.7 },
          { "cm": 48.5, "inch": 19.0 },
          { "cm": 50, "inch": 19.6 },
          { "cm": 51.5, "inch": 19.6 },
          { "cm": 53, "inch": 20.8 },
          { "cm": 54.5, "inch": 21.4 },
          { "cm": 56.5, "inch": 22.2 },
          { "cm": 58.5, "inch": 23.0 }
        ],
        "Sleeve Length": [
          { "cm": 62.5, "inch": 24.6 },
          { "cm": 62.5, "inch": 24.6 },
          { "cm": 63, "inch": 24.8 },
          { "cm": 64, "inch": 25.1 },
          { "cm": 65.5, "inch": 25.7 },
          { "cm": 65.5, "inch": 25.7 },
          { "cm": 67.5, "inch": 26.5 },
          { "cm": 67.5, "inch": 26.5 }
        ],
        "Bicep Width": [
          { "cm": 18.5, "inch": 7.2 },
          { "cm": 18.5, "inch": 7.2 },
          { "cm": 19.5, "inch": 7.6 },
          { "cm": 20, "inch": 7.8 },
          { "cm": 20, "inch": 7.8 },
          { "cm": 20.5, "inch": 8.0 },
          { "cm": 20.5, "inch": 8.0 },
          { "cm": 20.5, "inch": 8.0 }
        ],
        "Wrist Width": [
          { "cm": 13, "inch": 5.1 },
          { "cm": 13, "inch": 5.1 },
          { "cm": 13.5, "inch": 5.3 },
          { "cm": 14, "inch": 5.5 },
          { "cm": 14, "inch": 5.5 },
          { "cm": 14, "inch": 5.5 },
          { "cm": 14.5, "inch": 5.7 },
          { "cm": 14.5, "inch": 5.7 }
        ]
      }
    },
    "Double Breasted Jacket": {
      "Body Measurements": {
        "Size": [36, 38, 40, 42, 44, 46, 48, 50],
        "Jacket Length": [
          { "cm": 73.5, "inch": 28.9 },
          { "cm": 75, "inch": 29.5 },
          { "cm": 76.5, "inch": 30.1 },
          { "cm": 77, "inch": 30.3 },
          { "cm": 78, "inch": 30.7 },
          { "cm": 79, "inch": 31.1 },
          { "cm": 79.5, "inch": 31.2 },
          { "cm": 80, "inch": 31.4 }
        ],
        "Chest Width": [
          { "cm": 100, "inch": 39.3 },
          { "cm": 104, "inch": 40.9 },
          { "cm": 108, "inch": 42.5 },
          { "cm": 110, "inch": 43.3 },
          { "cm": 114, "inch": 44.8 },
          { "cm": 118, "inch": 46.4 },
          { "cm": 122, "inch": 48.0 },
          { "cm": 126, "inch": 49.6 }
        ],
        "Shoulder Width": [
          { "cm": 43, "inch": 16.9 },
          { "cm": 44, "inch": 17.3 },
          { "cm": 45, "inch": 17.7 },
          { "cm": 46, "inch": 18.1 },
          { "cm": 47, "inch": 18.5 },
          { "cm": 48, "inch": 18.8 },
          { "cm": 49, "inch": 19.2 },
          { "cm": 50, "inch": 19.6 },
          { "cm": 51, "inch": 20.0 }
        ],
        "Waist Width": [
          { "cm": 94, "inch": 37.0 },
          { "cm": 98, "inch": 38.5 },
          { "cm": 102, "inch": 40.1 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 108, "inch": 42.5 },
          { "cm": 112, "inch": 44.0 },
          { "cm": 116, "inch": 45.6 },
          { "cm": 120, "inch": 47.2 }
        ],
        "Sleeve Length": [
          { "cm": 62, "inch": 24.4 },
          { "cm": 62.5, "inch": 24.6 },
          { "cm": 62.5, "inch": 24.6 },
          { "cm": 64, "inch": 25.1 },
          { "cm": 65, "inch": 25.5 },
          { "cm": 65, "inch": 25.5 },
          { "cm": 66.5, "inch": 26.1 },
          { "cm": 66.5, "inch": 26.1 }
        ],
        "Bicep Width": [
          { "cm": 37, "inch": 14.5 },
          { "cm": 38, "inch": 14.5 },
          { "cm": 39, "inch": 15.3 },
          { "cm": 40, "inch": 15.7 },
          { "cm": 41, "inch": 16.1 },
          { "cm": 42, "inch": 16.5 },
          { "cm": 43, "inch": 16.9 },
          { "cm": 44, "inch": 17.3 }
        ],
        "Wrist Width": [
          { "cm": 26, "inch": 10.2 },
          { "cm": 26, "inch": 10.2 },
          { "cm": 27, "inch": 10.6 },
          { "cm": 28, "inch": 11.0 },
          { "cm": 28, "inch": 11.0 },
          { "cm": 28, "inch": 11.0 },
          { "cm": 29, "inch": 11.4 },
          { "cm": 29, "inch": 11.4 }
        ]
      },
      "Jacket Measurements": {
        "Size": [36, 38, 40, 42, 44, 46, 48, 50],
        "Jacket Length": [
          { "cm": 73.5, "inch": 28.9 },
          { "cm": 75, "inch": 29.5 },
          { "cm": 76.5, "inch": 30.1 },
          { "cm": 77, "inch": 30.3 },
          { "cm": 78, "inch": 30.7 },
          { "cm": 79, "inch": 31.1 },
          { "cm": 79.5, "inch": 31.2 },
          { "cm": 80, "inch": 31.4 }
        ],
        "Chest Width": [
          { "cm": 50, "inch": 19.6 },
          { "cm": 52, "inch": 20.4 },
          { "cm": 54, "inch": 21.2 },
          { "cm": 55, "inch": 21.6 },
          { "cm": 57, "inch": 22.4 },
          { "cm": 58, "inch": 22.8 },
          { "cm": 61, "inch": 24.0 },
          { "cm": 63, "inch": 24.8 }
        ],
        "Shoulder Width": [
          { "cm": 43, "inch": 16.9 },
          { "cm": 44, "inch": 17.3 },
          { "cm": 45, "inch": 17.7 },
          { "cm": 46, "inch": 18.1 },
          { "cm": 48, "inch": 18.9 },
          { "cm": 49, "inch": 19.2 },
          { "cm": 50, "inch": 19.6 },
          { "cm": 51, "inch": 20.0 }
        ],
        "Waist Width": [
          { "cm": 47, "inch": 18.5 },
          { "cm": 49, "inch": 19.3 },
          { "cm": 51, "inch": 20.0 },
          { "cm": 52.5, "inch": 20.6 },
          { "cm": 54, "inch": 21.2 },
          { "cm": 56, "inch": 22.0 },
          { "cm": 58, "inch": 22.8 },
          { "cm": 60, "inch": 23.6 }
        ],
        "Sleeve Length": [
          { "cm": 62, "inch": 24.4 },
          { "cm": 62.5, "inch": 24.6 },
          { "cm": 62.5, "inch": 24.6 },
          { "cm": 64, "inch": 25.2 },
          { "cm": 65, "inch": 25.6 },
          { "cm": 65, "inch": 25.6 },
          { "cm": 66.5, "inch": 26.2 },
          { "cm": 66.5, "inch": 26.2 }
        ],
        "Bicep Width": [
          { "cm": 18.5, "inch": 7.3 },
          { "cm": 19, "inch": 7.5 },
          { "cm": 19.5, "inch": 7.7 },
          { "cm": 20, "inch": 7.9 },
          { "cm": 20.5, "inch": 8.1 },
          { "cm": 21, "inch": 8.2 },
          { "cm": 21.5, "inch": 8.4 },
          { "cm": 22, "inch": 8.6 }
        ],
        "Wrist Width": [
          { "cm": 13, "inch": 5.1 },
          { "cm": 13, "inch": 5.1 },
          { "cm": 13.5, "inch": 5.3 },
          { "cm": 14, "inch": 5.5 },
          { "cm": 14, "inch": 5.5 },
          { "cm": 14, "inch": 5.5 },
          { "cm": 14.5, "inch": 5.7 },
          { "cm": 14.5, "inch": 5.7 }
        ]
      }
    },
    "Trousers": {
      "Body Measurements": {
        "Size": [30, 31, 32, 34, 36, 38, 40, 42],
        "Waist Width": [
          { "cm": 84, "inch": 33.0 },
          { "cm": 86, "inch": 33.8 },
          { "cm": 90, "inch": 35.4 },
          { "cm": 94, "inch": 37.0 },
          { "cm": 98, "inch": 38.5 },
          { "cm": 102, "inch": 40.1 },
          { "cm": 106, "inch": 41.7 },
          { "cm": 110, "inch": 43.3 }
        ],
        "Outseam": [
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 }
        ],
        "Thigh": [
          { "cm": 57, "inch": 22.4 },
          { "cm": 58, "inch": 22.8 },
          { "cm": 60, "inch": 23.6 },
          { "cm": 63, "inch": 24.8 },
          { "cm": 66, "inch": 26.0 },
          { "cm": 67, "inch": 26.3 },
          { "cm": 68, "inch": 26.8 },
          { "cm": 68, "inch": 26.8 }
        ],
        "Foot Opening": [
          { "cm": 16.5, "inch": 6.5 },
          { "cm": 16.5, "inch": 6.5 },
          { "cm": 17, "inch": 6.7 },
          { "cm": 17.5, "inch": 6.9 },
          { "cm": 17.5, "inch": 6.9 },
          { "cm": 17.5, "inch": 6.9 },
          { "cm": 18, "inch": 7.1 },
          { "cm": 18, "inch": 7.1 }
        ],
        "Rise": [
          { "cm": 64, "inch": 25.2 },
          { "cm": 65.5, "inch": 25.8 },
          { "cm": 66, "inch": 26.0 },
          { "cm": 67.5, "inch": 26.6 },
          { "cm": 68.5, "inch": 27.0 },
          { "cm": 70, "inch": 27.5 },
          { "cm": 70.5, "inch": 27.7 },
          { "cm": 70.5, "inch": 27.7 }
        ],
        "Inseam": [
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 }
        ]
      },
      "Trousers Measurements": {
        "Size": [30, 31, 32, 34, 36, 38, 40, 42],
        "Waist Width": [
          { "cm": 42, "inch": 16.5 },
          { "cm": 43, "inch": 16.9 },
          { "cm": 45, "inch": 17.7 },
          { "cm": 47, "inch": 18.5 },
          { "cm": 49, "inch": 19.3 },
          { "cm": 51, "inch": 20.1 },
          { "cm": 53, "inch": 20.8 },
          { "cm": 55, "inch": 21.6 }
        ],
        "Outseam": [
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 },
          { "cm": 105, "inch": 41.3 }
        ],
        "Thigh": [
          { "cm": 28.5, "inch": 11.2 },
          { "cm": 29, "inch": 11.4 },
          { "cm": 30, "inch": 11.8 },
          { "cm": 31.5, "inch": 12.4 },
          { "cm": 33, "inch": 13 },
          { "cm": 33.5, "inch": 13.2 },
          { "cm": 34, "inch": 13.3 },
          { "cm": 34, "inch": 13.3 }
        ],
        "Foot Opening": [
          { "cm": 16.5, "inch": 6.5 },
          { "cm": 16.5, "inch": 6.5 },
          { "cm": 17, "inch": 6.7 },
          { "cm": 17.5, "inch": 6.9 },
          { "cm": 17.5, "inch": 6.9 },
          { "cm": 17.5, "inch": 6.9 },
          { "cm": 18, "inch": 7.1 },
          { "cm": 18, "inch": 7.1 }
        ],
        "Rise": [
          { "cm": 64, "inch": 25.2 },
          { "cm": 65.5, "inch": 25.8 },
          { "cm": 66, "inch": 26.0 },
          { "cm": 67.5, "inch": 26.6 },
          { "cm": 68.5, "inch": 27.0 },
          { "cm": 70, "inch": 27.5 },
          { "cm": 70.5, "inch": 27.7 },
          { "cm": 70.5, "inch": 27.7 }
        ],
        "Inseam": [
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 },
          { "cm": 82, "inch": 32.3 }
        ]
      },
    }
  };
  function createSizeTable() {
    var i = 0;
    for (var groupKey in data) {
      var group = data[groupKey];
      var a = 0;
      for (var cellKey in group) {
        var cell = group[cellKey];

        var cellClass = '';
        if (i == 0) {
          cellClass = 'active2';
          if (a == 0) {
            cellClass = 'active active2';
          }
        }
        var headerContent = `<a class="table-sub-btn ${cellClass}" href="javascript: void(0);" data-table-key="${groupKey}" data-sub-key="${cellKey}">${cellKey}</a>`;
        try {
          console.log('Appending to .chart-table-sub-header:', headerContent);
          $('.chart-table-sub-header').append(headerContent);

        } catch (e) {
          console.error('Error appending to .chart-table-sub-header:', e);
        }

        var infoBtns = '';
        var tableClass = '';
        if (a == 0 && i == 0) {
          tableClass = 'active';
        }
        var tableHTML = `<table class="chart-table ${tableClass}" data-table-key="${groupKey}" data-sub-key="${cellKey}">`;
        for (var valuesKey in cell) {
          var values = cell[valuesKey];

          var infoBtn = valuesKey;
          if (valuesKey == 'Size') {
            infoBtn = `
					<div style="display: flex; letter-spacing: 1px; gap: 6px; justify-content: center; align-items: center;">Cm <div class="size-switch"><span></span></div> Inch</div>
					`;
          }
          if (valuesKey != 'Size') {
            infoBtn = `<div class="chart-info-btn" data-target="${valuesKey}"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"> <path d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z" fill="#D9D9D9"/> <path d="M6.125 7V10.5C6.125 10.9832 6.51675 11.375 7 11.375C7.48325 11.375 7.875 10.9832 7.875 10.5V7C7.875 6.51675 7.48325 6.125 7 6.125C6.51675 6.125 6.125 6.51675 6.125 7Z" fill="white"/> <path d="M7.875 3.5C7.875 3.01675 7.48325 2.625 7 2.625C6.51675 2.625 6.125 3.01675 6.125 3.5C6.125 3.98325 6.51675 4.375 7 4.375C7.48325 4.375 7.875 3.98325 7.875 3.5Z" fill="white"/> </svg> ${valuesKey}</div>`;
          }
          infoBtns += `<tr><td>${infoBtn}</td></tr>`;
          tableHTML += `<tr>`;
          for (var valueKey in values) {
            var value = values[valueKey];
            if (value.cm && value.inch) {
              tableHTML += `
							<td><span class="value-cm active">${value.cm}</span><span class="value-inch">${value.inch}</span></td>`;
            } else {
              tableHTML += `<td>${value}</td>`;
            }
          }
          tableHTML += `</tr>`;
        }
        tableHTML += `</table>`;
        $('.chart-table-base').append(`<table class="chart-table ${tableClass}" data-table-key="${groupKey}" data-sub-key="${cellKey}" style="min-width: inherit; width: 166px;">${infoBtns}</table>`);
        $('.chart-table-body').append(tableHTML);
        a++;
      }

      var headerClass = '';
      if (i == 0) {
        headerClass = 'active';
      }
      var headerContent = `<a class="table-btn ${headerClass}" href="javascript: void(0);" data-table-key="${groupKey}">${groupKey}</a>`;
      $('.chart-table-header').append(headerContent);
      i++;
    }
  }
  createSizeTable();

  $(document).on('click', '.size-switch', function () {
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
      $('.chart-table span.value-inch').addClass('active');
      $('.chart-table span.value-cm').removeClass('active');
    } else {
      $('.chart-table span.value-inch').removeClass('active');
      $('.chart-table span.value-cm').addClass('active');
    }
  });


  $(document).on('click', '.chart-table-header a', function () {
    $('.chart-table-header a').removeClass('active');
    $('.chart-table-sub-header a').removeClass('active2');
    $('.chart-table-sub-header a').removeClass('active');
    $(this).addClass('active');

    var table = $(this).data('table-key');
    $('.chart-table').removeClass('active');
    $('.chart-table-base .chart-table[data-table-key="' + table + '"]').first().addClass('active');
    $('.chart-table-body .chart-table[data-table-key="' + table + '"]').first().addClass('active');
    $('.chart-table-sub-header a[data-table-key="' + table + '"]').addClass('active2');
    $('.chart-table-sub-header a[data-table-key="' + table + '"]').first().addClass('active');
  });

  $(document).on('click', '.chart-table-sub-header a', function () {
    $('.chart-table-sub-header a').removeClass('active');
    $(this).addClass('active');

    var table = $(this).data('table-key');
    var tableCell = $(this).data('sub-key');
    $('.chart-table').removeClass('active');
    $('.chart-table-base .chart-table[data-table-key="' + table + '"][data-sub-key="' + tableCell + '"]').first().addClass('active');
    $('.chart-table-body .chart-table[data-table-key="' + table + '"][data-sub-key="' + tableCell + '"]').first().addClass('active');
  });

  $('.chart-popup .close-popup').click(function () {
    console.log('action 1')
    $('.chart-popup').removeClass('active');
    $('html').removeClass('overflow-hidden');
  });
  $('.size-popup .close-popup').click(function () {
    $('.size-popup').removeClass('active');
    $('html').removeClass('overflow-hidden');
  });
  $('.also-add-popup .close-popup').click(function () {
    $('.also-add-popup').removeClass('active');
    $('html').removeClass('overflow-hidden');
  });

  $(document).on('click', '.chart-open', function () {
    $('.chart-popup').addClass('active');
  });


  $(document).on('click', '.chart-info-btn', function () {
    var target = $(this).data('target');
    $('.chart-info-popup[data-popup="' + target + '"]').addClass('active');
    $('html').addClass('overflow-hidden');
  });

  $('.chart-info-popup .back-popup').click(function () {
    $('.chart-info-popup').removeClass('active');
    $('html').removeClass('overflow-hidden');
  });


  $(document).on('click', '.header-search-btn, .wd-toolbar-link .wd-custom-icon', function () {
    $('.form-popup').toggleClass('active');
  });

  $(document).on('click', '.search-detail-wrap span', function () {
    $(this).parent().toggleClass('active');
  });


  $(document).on('click', '.wcpf-field-button .wcpf-button, .filter-close', function () {
    $('#mobile-menu-new-search').addClass('hidden');
    $('.mobile-nav.wd-side-hidden.wd-left').removeClass('wd-opened');
    $('.sidebar-container').removeClass('wd-opened');
    $('.wd-close-side').removeClass('wd-close-side-opened');
  });

  $(document).on('click', '.show-sizes-btn', function () {
    $('html').addClass('overflow-hidden');
    $('.size-popup').addClass('active');
    console.log('ss', $('.size-popup'));
  });

});